'use client';

import { type ReactNode } from 'react';

import { Card, Heading } from '@backyard-ui/core';

import { Markdown } from '@/presenters/components/common/Markdown';
import { ShowMore } from '@/presenters/components/common/ShowMore';

interface TopContentProps {
  title: string | ReactNode;
  content?: string;
  children?: React.ReactNode;
}

function TopContent(props: Readonly<TopContentProps>) {
  const { title, content, children } = props;

  if (!content) {
    return <Heading UNSAFE_className="ml-2">{title}</Heading>;
  }

  return (
    <Card.Root data-testid="top-content-card-container">
      <Card.Header>
        <Heading>{title}</Heading>
      </Card.Header>
      <Card.Body>
        <ShowMore initialHeight={40} buttonAside>
          <Markdown content={content} />

          {children}
        </ShowMore>
      </Card.Body>
    </Card.Root>
  );
}

export default TopContent;
